export default {
  cancelOrderMap: {
    0: "no lo quiero",
    1: "extravió el producto",
    2: "Duplicar la orden",
    3: "Recepción fallida",
    4: "Otras razones",
  },
  "获取验证码": "Obtener código de verificación",
  "验证码": "Código de verificación",
  "请输入验证码": "Por favor ingrese el código de verificación",
  "发送":"Enviar",
  "已发送，请注意查收": "Enviado, por favor revise la recepción",
  "电商批发商场": "Mercado mayorista de comercio electrónico",
  "用户未发表评论": "El usuario no ha comentado",
  "请输入完整的支付密码!" : "Por favor ingrese la contraseña completa",
  "订单": "Orden",
  "下单成功，等待付款": "Pedido realizado correctamente, esperando pago",
  "下单成功，付款成功": "Pedido realizado con éxito, pago realizado correctamente",
  "已发货，正在运输中": "Enviado, en transporte",
  "订单已取消，原因:手动发起取消订单": "El pedido ha sido cancelado. Motivo: Cancelar el pedido manualmente.",
  "订单已取消，原因:超时自动取消订单": "El pedido ha sido cancelado. Motivo: el pedido se cancelará automáticamente cuando se agote el tiempo de espera.",
  "商家已确认，已进入备货状态": "El comerciante ha sido confirmado y ha ingresado al estado de stock.",
  "系统发货成功": "Entrega del sistema exitosa",
  "订单已签收": "Orden recibida",
  "发起退款申请": "Iniciar una solicitud de reembolso",
  "退款成功": "Reembolso exitoso",
  "退款失败": "Reembolso fallido",
  "订单退款成功": "Reembolso del pedido realizado correctamente",
  "订单退款失败": "Reembolso del pedido fallido",
  "系统默认好评": "El sistema muestra por defecto revisiones favorables.",
  "请输入关键字搜索": "Por favor ingrese la palabra clave para buscar",
  "猜你喜欢": "Supongo que te gusta",
  "订单已完成": "El pedido está completo",
  "热销推荐": "Recomendación de venta caliente",
  "头像选择": "Выбор аватара",
  "修改头像": "Modifica tu avatar",
  subOrder: "Orden de envio",
  "mailboxCheck": "Por favor complete la dirección de correo electrónico correcta",
  "switchLang": "Cambie a otro idioma para ver",
  "myCart": "Mi carrito de compras",
  "notQua": "No se cumplen las condiciones de calificación.",
  "noSmaller": "El monto aplicado no puede ser inferior a",
  "nomax": "La cantidad máxima de aplicación no puede exceder",
  "evaluationUploading": "Todavía tienes fotos subiendo. Por favor, inténtelo de nuevo más tarde",
  "evaluateInput": "Reseña con fotos",
  "moneyOrderStatus": "Estado del pedido",
  "coinBlock": "Acuerdo de divisas",
  "dealing": "En proceso",
  "dealSuccess": "Exitoso",
  "dealFail": "Fallar",
  "payCertificate": "Certificado de pago",
  "handleFee": "Cargo por servicio",
  "highOpinion": "Buenas críticas",
  "mediumOpinion": "Reseña media",
  "lowOpinion": "Malas críticas",
  "hasImage": "Con imagenes",
  "rechargeMethod": "Modo de recarga",
  "scanAndDown": "Escanear código QR Descargar aplicación",
  "receivedAddress": "dirección de recepción",
  "ActualLedger": "Recibo real",
  "view": "Vista",
  "withdrawNum": "Cantidad de retiro de efectivo",
  "rechargeNum": "Cantidad de recarga",
  "date": "Fecha",
  "walletHistory": "Historial de la billetera",
  "accountBalance": "Saldo de la cuenta",
  "accountReview": "Descripción de cuenta",
  "rated": "Revisado",
  "receiver": "Receptor",
  "orderStatus": "Estado",
  "orderTime": "Tiempo",
  "tax": "Impuestos",
  "discount": "Descuento",
  "productInfo": "Información del Producto",
  "paramError": "error de parametro",
  "orderInfo": "Información del pedido",
  "rebuy": "un pedido mas",
  "pleaseCorrectAddress": "Ingrese la dirección de retiro de efectivo correcta",
  "pleaseInputCorrectNumber": "Por favor, introduzca un número mayor que 0",
  "vcodePass": "¡Verificación superada!",
  "vcodeFail": "Autenticación fallida. Por favor intente de nuevo",
  "uploading": "Subiendo...",
  "uploadSuccess": "Subido correctamente",
  "uploadError": "Subida fallida. Inténtalo de nuevo",
  "registerSuccess": "Registro exitoso",
  "pleaseSetMobileNumber": "Por favor, establezca el número de teléfono",
  "unSelectedProduct": "No has seleccionado un producto",
  "loginSuccess": "Inicio de sesión exitoso",
  "pleaseSetAreaCode": "Ingrese el nombre del país y el código de área para buscar",
  "login": "Acceso",
  "register": "Registro",
  "logout": "Salida",
  "noData": "Datos no encontrados",
  "search": "Buscar",
  "historySearch": "Búsqueda histórica",
  "empty": "Vacío",
  "home": "Página principal",
  "favorableRate": "Tasa de buenas críticas",
  "classification": "Categoría",
  "searchTips": "Búsqueda de fuente/producto/proveedor/pedido",
  "dailyNewArrival": "Nuevos productos diarios enumerados",
  "more": "Más",
  "recommend": "Recomendación",
  "recommendedProducts": "Productos Recomendados",
  "recommendedStore": "Tiendas recomendadas",
  "buyNow": "Comprar ahora",
  "addCart": "Añadir al carro de la compra",
  "complex": "Integrado",
  "price": "Precio",
  "retailPrice": "Precio al por menor",
  "originPrice": "Precio original",
  "service": "Servicio al Cliente",
  "collect": "Favoritos",
  "sold": "El volumen de ventas",
  "pageviews": "Cantidad de navegación",
  "quantity": "Cantidad",
  "freight": "Carga",
  "shipping": "Envío",
  "ship": "Bote",
  "buyTips": "Envío dentro de las 24 horas posteriores a la realización del pedido. Los siguientes pedidos están bajo control logístico y pueden enviarse con retraso. Preste atención a la información de logística o comuníquese con el servicio al cliente.",
  "totalPrice": "Precio total",
  "addCartMessage": "Agregado con éxito al carrito de compras",
  "addCartMessageFaild": "El producto ya existe en el carrito de compras.",
  "myAccount": "mi qcuenta",
  "buyHistory": "Registros de compra",
  "wishlist": "productos favoritos",
  "trackOrder": "Orden",
  "account": "Cuenta:",
  "sellerZone": "área comercial",
  "beSeller": "Conviértete en comerciante",
  "sellerPanelLogin": "Inicio de sesión de comerciante",
  "footTip": "© Copyright {name} Ltd 2024",
  "footTips": "{name} Limited está autorizado y regulado por la Autoridad de Conducta Financiera como corredor de crédito (713206) y trata exclusivamente con el prestamista Home Retail Group CardServices Limited como {name} Financial Services. {name} Financial Services está autorizado y regulado por la Autoridad de Conducta Financiera para proporcionar crédito (716148). Home Retail GroupCard Services Limited está registrada en el Reino Unido (04007072) en Avebury, 489-499 Avebury Boulevard, Milton Keynes, Reino Unido. MK9 2NW.",
  "item": "Artículo",
  "checkout": "Haz un pedido",
  "productDescription": "Descripción del Producto",
  "userEvaluation": "Opiniones de los usuarios",
  "AllProducts": "Todos los productos",
  "followers": "Seguir",
  "sales": "El volumen de ventas",
  "visitStore": "Visita la tienda",
  "authentic": "100% genuino",
  "dayReturns7": "7 días de regreso",
  "shippingDiscounts": "descuento de flete",
  "safePayment": "Pago seguro",
  "followed": "Seguido",
  "dashboard": "Tablero de instrumentos",
  "myOrder": "Mi pedido",
  "setUp": "Configuración",
  "successTips": "Exitoso",
  "copySuccess": "Replicación exitosa",
  "balance": "Saldo (USDT)",
  "sort": "Tipo",
  "commodity": "Producto",
  "browse": "El volumen de ventas",
  "recharge": "Recargar",
  "commodityCollection": "colección de productos",
  "withdraw": "Retiro de efectivo",
  "defaultAddress": "Dirección predeterminada",
  "addNewAddress": "agregar nueva dirección",
  "withdrawRecord": "registro de retiro de efectivo",
  "serialNumber": "N º de pedido.",
  "time": "Tiempo",
  "amount": "Cantidad",
  "processing": "En proceso",
  "fail": "Fallar",
  "blockchainNetwork": "Red de cadena de bloques",
  "records": "Registro",
  "withdrawAddress": "Dirección de retiro de efectivo",
  "withdrawInputTips": "Por favor ingrese la dirección de retiro",
  "copy": "Replicación",
  "enterTips": "Por favor escribe",
  "actualAccount": "cuenta real",
  "handlingFee": "Cargo por servicio",
  "confirm": "Confirmar recibo",
  "previous": "Paso anterior",
  "pleaseEnterAddress": "Por favor ingrese la dirección",
  "pleaseEnterQuantity": "Por favor ingrese la cantidad",
  "withdrawSuccess": "Pedidos enviados con éxito",
  "saveQr": "Guardar código QR",
  "pleaseEnterAmount": "Por favor ingrese el monto de la recarga",
  "expectedArrival": "Llegada prevista",
  "currentRate": "Tipo de cambio actual",
  "uploadTips": "Comprobante de pago (Subir captura de pantalla de los detalles del pago)",
  "clickUpload": "Haga clic para cargar",
  "uploadPhoto": "por favor sube fotos",
  "rechargeSuccessful": "recarga exitosa",
  "rechargeTips": "\"Mensaje de recarga: \"\"Por favor, complete el monto real de la transferencia con veracidad. De lo contrario, el sistema puede fallar en pasar la aprobación y afectar el progreso de la recarga.\"",
  "rechargeRecord": "Registro de recarga",
  "all": "Todo",
  "pending": "A pagar",
  "cancelled": "Cancelado",
  "delivered": "Para ser enviado",
  "confirmed": "Confirmado",
  "receipt": "Para ser recibido",
  "harvested": "Recibió",
  "comment": "Para ser revisado",
  "refund": "Reembolso/postventa",
  "cancelOrder": "Cancelar orden",
  "cancelReason": "Razón de la cancelación",
  "cancelOrderTitle": "Seleccione un motivo de cancelación del pedido",
  "returnOrderTitle": "Por favor selecciona el motivo de la devolución",
  "refundInstructions": "Instrucciones de reembolso",
  "returnDetailTips": "Por favor, dé una opinión sobre el producto.",
  "cancel": "Cancelar orden",
  "cancelOrder1": "Producto no recibido",
  "cancelOrder2": "No me gusta, no lo quiero",
  "cancelOrder3": "El vendedor envió los productos equivocados.",
  "cancelOrder4": "marca falsa",
  "cancelOrder5": "Menos envío, envío perdido",
  "cancelOrder6": "Producto recibido dañado",
  "cancelOrder7": "hay un problema de calidad",
  "cancelOrder8": "Negociar el reembolso con el comerciante",
  "cancelOrder9": "Otras razones",
  "cancelOrderSuccess": "Pedido cancelado con éxito",
  "returnOrderSuccess": "Enviar con éxito",
  "orderName": "Nombre",
  "orderEmail": "Correo electrónico",
  "orderAddress": "DIRECCIÓN",
  "orderNation": "País",
  "orderState": "Estado",
  "orderCity": "Ciudad",
  "orderPostCode": "Código Postal",
  "orderAmount": "Cantidad",
  "orderPrefix": "Orden total",
  "orderFee": "Impuestos",
  "orderSpecification": "Especificación",
  "orderCommodity": "Producto",
  "orderQuantity": "Cantidad",
  "orderUnitprice": "Precio unitario",
  "orderFreight": "Carga",
  "orderTax": "Impuesto",
  "orderTotal": "Total",
  "PaymentOrder": "Orden de pago",
  "Evaluate": "Revisar",
  "CancelOrder": "Cancelar orden",
  "RemindShip": "Recordatorio para el envío",
  "Refund": "Reembolso",
  "Submitareview": "Enviar reseñas",
  "Information": "Información",
  "wrongPassword": "Error de contraseña más de 3 veces. Inténtalo de nuevo mañana.",
  "Operate": "Operación",
  "Item": "Elementos)",
  "From": "De",
  "hint": "Consejos",
  "CheckDetails": "Ver detalles",
  "Payment": "Pago",
  "Cancel": "Cancelar",
  "refundSuccessfully": "Reembolso exitoso",
  "pendingPayment": "A pagar",
  "pay": "Pago",
  "LoginPassword": "Contraseña de inicio de sesión",
  "sure": "Por supuesto",
  "shippingAddress": "Dirección de recepción",
  "pleaseAddShippingAddress": "Por favor, añade una dirección de envío primero",
  "transactionPassword": "Clave de transacción",
  "markDefaultAddress": "Marcar como dirección de envío predeterminada",
  "edit": "Editado por",
  "delete": "Borrar",
  "Opt": "Seleccionar",
  "piece": "PC",
  "orderDetails": "Detalles del pedido",
  "shopCollection": "Añadir la tienda a favoritos",
  "addAddress": "agregar nueva dirección",
  "signUp": "Registro",
  "loginTips": "¿Ya tienes una cuenta?",
  "loginIn": "Acceso",
  "mobile": "Telefono no",
  '购物车还没有商品': "El carrito de compras no tiene productos",
  '去购物': "Ir de compras",
  "modifyAddress": "Modificar dirección",
  "desc": "Establecer como dirección predeterminada",
  "keep": "Mantener",
  "onlineService": "Servicios en línea",
  "send": "Enviar",
  "EsShop": "Tienda en línea",
  "desc3": "Ingrese la contraseña de la transacción",
  "desc4": "Ingrese su contraseña de transacción",
  "desc6": "Ingrese su contraseña de transacción nuevamente",
  "setUpPayPaw": "Establecer contraseña de transacción",
  "setSuccess": "Configuración exitosa",
  "confirmPayPaw": "Confirmar contraseña de transacción",
  "paymentSuccessful": "Pago exitoso",
  "paymentPending": "Pago pendiente",
  "paymentPendingDesc": "Su pago está siendo procesado. Por favor, verifique el estado de su pedido más tarde",
  "desc5": "¿Dirección de envío incorrecta? Contacto",
  "customeService": "Atención al cliente en línea",
  "BackHome": "Volver a la página de inicio",
  "Checkorder": "Ver pedido",
  "ForgotPassword": "¿Olvidaste la contraseña?",
  "signIn": "Acceso",
  "noAccount": "¿Sin número de cuenta?",
  "pleaseEnterAccount": "Por favor ingrese número de cuenta",
  "pleaseEnterPassword": "Por favor, ingrese contraseña",
  "password": "Contraseña",
  "mobilePhone": "Número de teléfono",
  "pleaseEnterPhoneNumer": "Por favor, establezca el número de teléfono",
  "setPassword": "Configurar la clave",
  "noDataFound": "Datos no encontrados",
  "searchCountry": "Ingrese el nombre del país y el código de área para buscar",
  "pleaseEnterEmail": "Configure el buzón",
  "invitationCode": "Código de invitación",
  "plaeseEnterInvitaionCode": "Por favor, establezca el código de invitación",
  "pleaseSetLoginPassword": "Por favor, establezca la contraseña de inicio de sesión",
  "selectDeliveryAddress": "Seleccione la dirección de envío",
  "totalOf": "Total",
  "items": "Artículo",
  "orderSummary": "Resumen del pedido",
  "paymentMethod": "Método de pago",
  "Balance": "Balance",
  "payPal": "Paypal",
  "notOpen": "Este método de pago aún no está abierto en su región",
  "mastercard": "tarjeta MasterCard",
  "additional": "Extra",
  "handlingfee": "Cargo por servicio requerido",
  "goodsNumber": "Cantidad de productos",
  "deliveryFee": "Transporte",
  "totalNum": "Total",
  "new": "Nuevo",
  "oldPassword": "Contraseña anterior",
  "pleaseEnterOldPassword": "Por favor ingrese la contraseña anterior",
  "newPassword": "Nueva contraseña",
  "plaseeEnterNewPassword": "Por favor ingrese la nueva contraseña",
  "confirmPassword": "Confirmar Contraseña",
  "plaseeENterConfirmPassword": "Por favor ingrese la contraseña de confirmación",
  "twoPawword": "Dos contraseñas no son lo mismo",
  "rechargeAddress": "Dirección de recarga",
  "plaseEnterRechargeAddress": "Por favor, introduzca la dirección de recarga",
  "userCenter": "centro personal",
  "merchantSettled": "Entrada de comerciante",
  "upNew": "Nuevo producto listado",
  "balanceNot": "El saldo no es suficiente. Por favor, recarga.",
  "NoProductSelected": "Producto aún no seleccionado",
  "ShippingAddressNotSet": "Dirección de envío no establecida",
  "consigneeName": "Nombre del receptor",
  "email": "Correo electrónico:",
  "areaCode": "código de área internacional",
  "phoneNumber": "Número de teléfono",
  "nation": "País",
  "state": "Provincia/Estado/Estado",
  "city": "Ciudad",
  "postCode": "Código Postal",
  "address": "Dirección detallada",
  "addAddressOrModifyAddress": "Añadir nueva dirección/Modificar dirección",
  "setAsTheDefaultAddress": "Establecer como dirección predeterminada",
  "proceed": "Continuar",
  "btnSure": "Confirmar",
  "pleaseInput": "Por favor escribe",
  "allProduct": "Todos los productos",
  "myCommodityCollection": "productos favoritos",
  "myFollowedShops": "Sigue la tienda",
  "mySold": "Vendido",
  "myPageviews": "Cantidad de navegación",
  "myPraiseRate": "Tasa de buenas críticas",
  "myUnfollow": "Dejar de seguir",
  "inputNum": "Números",
  "inpuEmailErro": "Por favor, introduzca la dirección de correo electrónico correcta",
  "goodsShip": "Envío",
  "goodsShipTips": "Los productos serán enviados dentro de las 24 horas posteriores a la realización del pedido. Si existe control logístico para el siguiente pedido, el pedido puede retrasarse. Preste atención a la información de logística del pedido o comuníquese con el servicio al cliente.",
  "goodsFreight": "Transporte",
  "goodsFreeShipping": "Gratis",
  "goodsFreightTips1": "1. Composición del flete transfronterizo del producto: flete = tarifa de envío + flete de larga distancia + tarifa de entrega",
  "goodsFreightTips2": "2. Si no se cumplen las condiciones del franqueo, el flete se cobrará según las condiciones reales.",
  "goodsFreightTips3": "3. El derecho de interpretación final pertenece a la plataforma.",
  "pleaseValidPostCode": "Por favor ingrese más de 4 dígitos",
  "pleaseValidEmail": "Por favor, introduzca la dirección de correo electrónico correcta",
  "pleaseValidPhone": "Por favor ingrese el número de teléfono correcto",
  "productAvailable": "Este producto ha sido eliminado",
  "validatorMaxNumber": "La cantidad excede el límite",
  "validatorRequire": "Los elementos obligatorios no pueden ser nulos",
  "validatorPhone": "Por favor ingrese el número de teléfono correcto",
  "validatorEmail": "Ingrese el formato de correo electrónico correcto",
  "validatorPassword": "La contraseña se compone de 6-12 dígitos o letras(contiene caracteres especiales)",
  "validatorSixNumber": "Por favor ingrese 6 dígitos puros",
  "validatorFourMoreNumber": "Ingrese una combinación de 4-32 dígitos o letras",
  "validatorIpRule": "Formato de IP incorrecto",
  "validatorChineseAndEnglish": "Solo chino e inglés, ingrese el rango: 8-64 caracteres",
  "collectionSuccess": "Añadir a favoritos con éxito",
  "followedSuccess": "Seguir correctamente",
  "cancelSuccess": "Cancelado correctamente",
  "evaluateOrder": "Reseña con fotos",
  "evaluateOrderPlaceholder": "Por favor revise los productos",
  "operationSuccess": "Operación exitosa",
  "confirmReceiveGoods": "Confirmar la recepción del producto o no",
  "evaluateOrderSuccess": "Revisión exitosa",
  "yesterday": "Ayer",
  "notLogin": "Aún no has iniciado sesión.",
  "delAllHistoryRecord": "¿Está seguro de que desea eliminar todo el registro del historial?",
  "or": "O",
  "tipsRemindsText": "El comerciante recibirá un recordatorio después de que se le recuerde el envío.",
  "tipsRemindsCount": "Solo se puede recordar una vez.",
  "tipsRemindsMerchant": "recordar a los comerciantes",
  "tipsRemindsSuccess": "Recordatorio exitoso",
  "noCartTips": "Tu bolsa de compras está vacía. Empieza a comprar.",
  "defaultRate": "El sistema muestra por defecto revisiones favorables.",
  "prevPage": "Pagina anterior",
  "nextPage": "Siguiente página",
  "returnApply": "Petición para reembolso",
  "returnReason": "motivo del reembolso",
  "returnAmount": "Importe devuelto",
  "returnRemark": "Instrucciones de devolución",
  order: {
    confirm: "Confirmar recibo",
    cancel: "Cancelar orden",
    payment: "Pagar ahora",
    remind: "Recordatorio para el envío",
    return: "Solicitud de reembolso del producto",
    evaluate: "Revisar ahora",
    logistics: "ver logística",
    noRefund: "no reembolsado",
    refunding: "Reembolso en curso",
    refundSuccess: "Reembolso exitoso",
    refundFail: "Reembolso fallido",
  },
  "remindTitle": "Recordatorio para el envío",
  "remindContent": "Después de que se recuerda el envío, el comerciante recibirá el recordatorio. Solo se puede recordar una vez.",
  "remindSuccess": "Recordatorio exitoso",
  "remindRepeat": "Este pedido ha sido recordado.",
  "noComments": "No hay revisión en este momento",
  "storeSeach": "Buscar producto en esta tienda",
  "storeSeachTips1": "encontrado para ti",
  "storeSeachTips2": "Tiendas relacionadas encontradas",
  "storeSeachTips3": "Hogar",
  "creditTit": "Servicios de crédito",
  "getCoupons": "Obtén más cupones",
  "yourEmail": "Su dirección de correo electrónico",
  "subscription": "Suscripciones",
  "paymethods": "Método de pago",
  "footdec": "Los usuarios del sitio global de {name} provienen de {num} países de todo el mundo y utilizan {coin} para la liquidación. {coin} es una transacción sin fronteras que permite transacciones inmediatas y de bajo costo en todo el mundo sin esperas ni tarifas internacionales.",
  "custService": "Servicio al Cliente",
  "helpLine": "Atención al cliente en línea",
  "contactUs": "Contáctenos",
  "partner": "Proveedores cooperativos",
  "buyRules": "reglas del comprador",
  "sellerRules": "política del vendedor",
  "returnsAndEx": "Devoluciones y Cambio",
  "servicePolicy": "Política de servicio",
  "returnPolicy": "Política de devoluciones",
  "user_Center": "Centro de usuarios",
  "userReg": "Registro de usuario",
  "orderTrack": "consulta de pedido",
  "purchageHistory": "Historial de compras",
  "myPurse": "Mi billetera",
  "aboutUs": "Sobre nosotros",
  "Recruitment": "Espera a personas talentosas",
  "news": "Información de noticias",
  "stateMent": "Declaración de la esclavitud moderna",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "okx",
  "metaMask": "metamáscara",
  "homeBannertips1": "Conviértete en comerciante",
  "homeBannertips2": "comisión total",
  "homeBannertips3": "máx.",
  "homeBannerbtn": "Únete ahora",
  "homeDownloadtips1": "Centro comercial mayorista de comercio electrónico transfronterizo",
  "homeDownloadtips2": "oferta especial de la marca",
  "homeDownloadtips3": "descuento continuo",
  "homeDownloadtips4": "descarga de android",
  "homeDownloadtips5": "descarga de manzana",
  "homeDownloadtips6": "Escanee el código QR para descargar la aplicación",
  "homeIconTips1": "100% genuino",
  "homeIconTips2": "7 días de regreso",
  "homeIconTips3": "descuento de flete",
  "homeIconTips4": "pago seguro",
  "headerSearchTips": "Por favor ingrese la palabra clave para buscar",
  "collAccount": "modo de prestamo",
  "mine": "Mío.",
  "creditText1": "Los préstamos iniciales resuelven el problema de pedir dinero prestado",
  "creditText2": "Proporcionar servicios de préstamo de puesta en marcha y rotación de capital",
  "creditWorry": "Préstamo sin preocupaciones",
  "creditQuota": "Límite flexible",
  "creditQuotaINFO": "100.000 a 30.000.000 con límite flexible y sin restricciones, con un plazo máximo de préstamo de un año.",
  "quickLoan": "préstamo rápido",
  "creditReview": "Pase la auditoría en una hora como mínimo, si se pasa la revisión, el préstamo se liberará de inmediato.",
  "safe": "Seguro y sin preocupaciones",
  "safeInfo": "Sin hipoteca, sin depósito, sin devolución de llamada, porque esto es en realidad un asunto privado.",
  "about": "Sobre nosotros",
  "aboutText1": "\"Estamos comprometidos con los servicios financieros de préstamo, basados en la filosofía empresarial de \"\"cliente primero\"\", tenemos la misión de resolver el problema de la rotación de capital del cliente. Desde su creación, la empresa ha ayudado a numerosos clientes a resolver el problema de la rotación de capital.\"",
  "aboutText2": "Límite: 100,000-30,000,000, método de pago flexible con bajo interés, sin cargo por adelantado, préstamo en línea, sin llamadas telefónicas para verificación, información confidencial y préstamos en el mismo día.",
  "contactUs1": "Si no desea pedir dinero prestado a sus compañeros de nivel, contáctenos.",
  "committed": "Comprometidos con los servicios de préstamos para emprendedores",
  "financial": "Aborde sus preocupaciones financieras",
  "partnersTit": "Plataforma de préstamos en línea para socios",
  "application": "Solicitud de préstamo",
  "applicant": "Solicitante",
  "actualName": "Nombre real",
  "yourName": "Por favor ingrese el nombre",
  "term": "Plazo de préstamo",
  "applicationAmount": "Monto requerido",
  "rates": "Tasa de interés del préstamo",
  "loanMethod": "modo de prestamo",
  "accountB": "Saldo de la cuenta",
  "countryOf": "Nacionalidad",
  "myloan": "mi prestamo",
  "applyLoan": "Solicitar un préstamo",
  "loaned": "prestado",
  "interest": "Intereses acumulados",
  "esRepayment": "Reembolso estimado",
  "loanHistory": "registro de préstamo",
  "applicantDate": "Fecha de aplicacion",
  "repayment": "Reembolso",
  "cycle": "Ciclo de reembolso",
  "fixedRate": "Tasa de interés fija",
  "successLoan": "Préstamo exitoso",
  "Reapply": "Aplicar de nuevo",
  "borrow": "Préstamo fallido",
  "applicantIn": "Solicitud en curso",
  "repaid": "Reembolso",
  "overdue": "Atrasado",
  "estirepay": "Reembolso estimado",
  "loanDays": "Número de días prestados",
  "reAmount": "monto de reembolso",
  "repay": "Modo de pago",
  "entRepay": "Confirmar reembolso",
  "foryourmoney": "Si tiene escasez de fondos, no encuentra dónde pedir dinero prestado o le da vergüenza pedir dinero prestado a sus amigos, puede contactarnos. Contamos con todo el proceso de servicio profesional para responder tus dudas en cualquier momento. Nuestro objetivo es hacer que cada préstamo sea transparente, para que los clientes puedan usarlo de forma rápida y segura.",
  "onlineApplin": "Aplica online",
  "businessloan": "Solicitud de préstamo de puesta en marcha",
  "selectCountry": "Por favor seleccione una nacionalidad",
  "selectPeriod": "Por favor seleccione un período",
  "passPortImg": "Nº de DNI/Nº de Pasaporte",
  "uploadId": "Carga de foto de certificado/pasaporte",
  "readAndAgree": "He leído y estoy de acuerdo",
  "loanAgree": "Acuerdo de prestamo",
  "submitApplica": "Presentación de solicitud",
  "photoExample": "Ejemplo de toma de fotografías.",
  "discounted": "productos con descuento",
  "days": "día",
  "privacyPolicy": "Política de privacidad",
  "delivery": "Entrega y recogida",
  "checkAgreement": "¡Marque el acuerdo!",
  "businessPhone": "Teléfono de negocios",
  "businessEmail": "Correo electrónico corporativo",

  "提交失败": "Enviar fallido",
  "充值金额不能小于1": "El importe de la recarga no puede ser inferior a 1 (incluidos dos decimales)",
  "请切换其他语言后查看": "Cambie a otro idioma para ver",
  "我的购物车": "Mi carrito de compras",
  "推荐商品": "Productos Recomendados",
  "猜你喜欢": "Supongo que te gusta.",
  "暂无店铺": "No se encontró ninguna tienda",
  "添加失败": "Error al enviar. Por favor, inténtelo de nuevo más tarde",
  "提交订单": "Envío de pedidos",
  recommendclass: "Categoría recomendada",
  "滑动验证": "Validación deslizante",
  "最多上传9张图片": "Máximo 9 fotos",
  "账号注销": "Cierre de sesión",
  "App下载(买家端)": "Descarga de App (comprador)",
  "App下载(卖家端)": "Descarga de App (vendedor)",
  "确定注销": "Confirmar cierre de sesión",
  "您的账号": "Su cuenta",
  "为什么要离开": "¿Por qué dejar",
  "您还有余额,不能注销账号": "Todavía tienes saldo, no puedes cerrar sesión!",
  "请输入注销理由": "Ingrese el motivo de cierre de sesión",
  "您确认要注销吗?": "¿Estás seguro de que quieres cerrar sesión?",
  "我再考虑下": "Lo pensaré de nuevo",
  "同意注销": "De acuerdo en cerrar sesión",
  "注销成功": "Cierre de sesión exitoso",
  "请选择": "Por favor seleccione",
  "绑定成功": "Vinculación exitosa",
  "提款地址绑定": "Vinculación de dirección de retiro",
  "加值": "Recarga",
  "提领": "Retiro",
  "平台人工发起退款": "Reembolso iniciado por el personal de la plataforma",
  "银行卡": "Tarjeta bancaria",
  "联系商家": "Contactar al vendedor",
  footTipTikTok:'CoveBuy ©️2024 Derechos de autor',
  "备注": "Observaciones",
  "最多包含10位小数": "Máximo 10 decimales",
  "长时间未付款，系统自动取消订单": "Si no paga durante mucho tiempo, el sistema cancelará el pedido automáticamente",
  "企业电话": "Teléfono de negocios",
  "当前余额": "Saldo actual",
  "职业机会": "Oportunidad de carrera",
  "加密货币": "Moneda cifrada",
  "银行卡": "Tarjeta bancaria",
  "充值币种": "Moneda de recarga",
  '参数缺失': "Falta de parámetros",
  '充值数量必填': "La cantidad de recarga es obligatoria",
  "充值金额": "Importe de recarga",
  "充值金额不得小于": "El importe de la recarga no puede ser inferior a",
  "充值金额不得大于": "El importe de la recarga no puede ser superior a",
  "请先选择币种": "Por favor seleccione la moneda primero",
  "开户行": "Banco",
  "请输入开户行名称": "Ingrese el nombre del banco",
  "银行卡号": "Número de tarjeta bancaria",
  "请输入银行卡号": "Ingrese el número de tarjeta bancaria",
  "点击去支付": "Haga clic para pagar",
  "企业证明": "Certificado de empresa",
  "客户端下载": "Descargar cliente",
  "提现方式": "Forma de retiro",
  "仅能绑定一个收款地址!": "¡Solo se puede vincular una dirección de recepción!",
  "cancelInfo":"¡advertir! Tenga cuidado de cancelar la cuenta. Si ya no usa la cuenta, puede hacer clic en [Aceptar la cancelación]. Es posible que no pueda registrarse dentro de unos días después de la cancelación.",
  "betaBannerText": "El sitio web está en pruebas públicas, no realize pedidos por favor",
  TikTokFoot:"CoveBuy es una plataforma social global de videos cortos CoveBuy y la empresa comercial mayorista más grande de Asia, Alibaba, establecida en cooperación. Es una plataforma global de comercio electrónico y tiene tres almacenes inteligentes autónomos en el mundo, ubicados en Toronto, Canadá, Los Ángeles y Chiba, Japón. Los productos a la venta en la aplicación incluyen productos populares de Japón, Corea del Sur, China y otros países asiáticos. En la actualidad, el número total ha superado los 50.000 y continúa creciendo rápidamente."
}